import { Stack } from '@findy-code/yuffie/ui/stack';
import Link from 'next/link';
import type { MouseEventHandler, ReactElement } from 'react';

import styles from './tabs.module.scss';

export interface TabItem {
  current: boolean;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  path: string;
  label: string;
}

const Tabs = (props: {
  companyName?: string;
  url: string;
  items: TabItem[];
}) => {
  const list: ReactElement[] = [];
  props.items.forEach((item) => {
    list.push(
      <div className={styles.tabItem} key={item.path}>
        <Link
          className={styles.tabAnchor}
          data-current={item.current || undefined}
          href={item.path}
          onClick={item.onClick}
        >
          <span>{item.label}</span>
        </Link>
      </div>
    );
  });

  return (
    <Stack
      className={styles.tabBlock}
      direction="row"
      justify="start"
      spacing={0}
    >
      {list}
    </Stack>
  );
};

export { Tabs };
